/** @jsx jsx */
import { jsx, css } from '@emotion/core';
import { colorsPalette } from '../../../styles/colors';

const dotCss = css({
  // Modify the font for one that has the period as a rounded dot. This combination is widely used in Windows and Mac
  // Computers. Check https://www.cssfontstack.com/Georgia for more information
  fontFamily: 'Georgia, Times, Times New Roman, serif',

  // Add this value to avoid font size change affecting parent line height.
  lineHeight: 0.1,

  fontSize: '1.4em',
  color: colorsPalette.red,
});

const DotComponent = () => (
  <span aria-hidden css={dotCss}>
    .
  </span>
);

DotComponent.displayName = 'DotComponent';

export default DotComponent;
